import React, { Component } from "react";
import { isFunction } from "lodash";

class LoadListOnScroll extends Component {
  componentDidMount() {
    this.loadMore();
  }

  loadMore = () => {
    const { distance, callApiOnScroll } = this.props;
    const defaultDistance = distance || 0;
    this.element &&
      this.element.getElementsByClassName("scroll")[0] &&
      this.element
        .getElementsByClassName("scroll")[0]
        .addEventListener("scroll", event => {
          if (
            event.target.scrollTop +
              event.target.offsetHeight +
              defaultDistance >=
            event.target.scrollHeight
          ) {
            isFunction(callApiOnScroll) && callApiOnScroll();
          }
        });
  };

  render() {
    const { children } = this.props;
    return (
      <div
        ref={elem => {
          this.element = elem;
        }}
      >
        {children}
      </div>
    );
  }
}

export default LoadListOnScroll;
